import { useMemo } from "react";
import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";
import { buildDeviceDebugMeta, buildDeviceDebugProperties } from "./debug/deviceDebugMock.js";
import { buildDebugPanelTokens } from "./debug/deviceDebugTheme.js";

export function DevicePropertiesSection({ device }) {
  const { c, dark, accentHex: A } = useThemeSlice();
  const tk = useMemo(() => buildDebugPanelTokens(c, dark, A), [c, dark, A]);
  const meta = buildDeviceDebugMeta(device);
  const properties = buildDeviceDebugProperties(device);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <div style={{ background: c.card, border: `1px solid ${c.cardBdr}`, borderRadius: tk.radius, overflow: "hidden", boxShadow: tk.shadowSm }}>
        <div style={{ height: 2, background: tk.accentBar }} />
        <div style={{ padding: "12px 14px" }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: c.sub, marginBottom: 4 }}>Device</div>
          <div style={{ fontSize: 12, fontWeight: 800, color: c.text, fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace", lineHeight: 1.35, wordBreak: "break-all" }}>
            {meta.title}
          </div>
          <div style={{ fontSize: 10.5, color: c.sub, marginTop: 4, fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}>{meta.subtitle}</div>
        </div>
      </div>

      <div style={{ background: c.card, border: `1px solid ${c.cardBdr}`, borderRadius: tk.radius, overflow: "hidden", boxShadow: tk.shadowSm }}>
        <div style={{ padding: "10px 14px", borderBottom: `1px solid ${c.divider}`, background: c.hover }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: c.sub }}>Properties</div>
        </div>
        {properties.map(([label, value], idx) => (
          <div
            key={label}
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(110px, 44%) 1fr",
              gap: 12,
              padding: "9px 14px",
              borderBottom: idx < properties.length - 1 ? `1px solid ${c.divider}` : undefined,
              alignItems: "start",
            }}
          >
            <span style={{ fontSize: 10.5, color: c.sub, fontWeight: 600, lineHeight: 1.4 }}>{label}</span>
            <span style={{ fontSize: 11.5, color: c.text, fontWeight: 600, fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace", wordBreak: "break-all", lineHeight: 1.4 }}>{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
